import { render, staticRenderFns } from "./LeaguesTable.vue?vue&type=template&id=4e9d30f0&scoped=true&"
import script from "./LeaguesTable.vue?vue&type=script&lang=js&"
export * from "./LeaguesTable.vue?vue&type=script&lang=js&"
import style0 from "./LeaguesTable.vue?vue&type=style&index=0&id=4e9d30f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9d30f0",
  null
  
)

export default component.exports